import { Bell } from 'lucide-react';
import { useNotifications } from '@/contexts/NotificationContext';

export function NotificationBellTrigger() {
  const { unreadCount, openListView } = useNotifications();

  return (
    <button
      onClick={openListView}
      className="relative p-2 text-muted-foreground hover:text-foreground hover:bg-secondary rounded-lg touch-target focus:outline-none focus-visible:outline-none"
      aria-label="Open notifications"
    >
      <Bell className="w-6 h-6" />
      {unreadCount > 0 && (
        <span className="absolute top-1 right-1 w-5 h-5 bg-destructive text-destructive-foreground text-xs font-bold rounded-full flex items-center justify-center">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      )}
    </button>
  );
}
